exports.default = {
  'download_success': 'Image download successful',
  'download_failed': 'Image download failed',
  'code_copy_success': 'Code copied successfully',
  'copy_failed': 'Copy failed',
  'chart_not_found': 'Chart not found',
  'container_not_found': 'Container not found',
  'fullscreen_failed': 'Fullscreen display failed',
  'image_copied_to_clipboard': 'Copied!',
  'copy_image_failed_unsupported': 'Failed to copy image, your browser may not support this feature',
  'copy_image_failed': 'Failed to copy image',
  // Toolbar related
  'chart_tab': 'Chart',
  'code_tab': 'Code',
  'download_image_tooltip': 'Download Image',
  'copy_image_tooltip': 'Copy Image',
  'zoom_in_tooltip': 'Zoom In',
  'zoom_out_tooltip': 'Zoom Out',
  'fit_page_tooltip': 'Fit to Page',
  'fullscreen_tooltip': 'Fullscreen View',
  'copy_code_tooltip': 'Copy Code',
  // Status messages
  'image_generating': 'Generating image',
  'image_generation_failed': 'Image generation failed',
  'waiting_code_complete': 'Waiting for code completion...',
  'switch_to_code_view': 'Please switch to code view to see the original code'
}
